export function debounce(delay: number = 500): MethodDecorator {
    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
        let timer = null;
        const original = descriptor.value;
        
        descriptor.value = function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => original.apply(this, args), delay);
        };
        return descriptor;
    };
}